import { useEffect } from 'react'
import { Card, Tabs, Skeleton } from 'antd'
import { Clock, Hexagon, Shield } from 'react-feather'
import { WeaverQuery } from 'Services/WeaverUtils'
import { getNodeLabel } from 'Services/WeaverUtils'
import NodeDetails from './NodeDetails'
import { useDetailData } from './DetailDataProvider'
import { setLoading, setNode } from './DetailDataProvider/actions'
{ TabPane } = Tabs
import './index.scss'

DetailView = ({ nodeId }) ->

  [{ node }, dispatch] = useDetailData()

  useEffect( ->
    ( ->
      node = await new WeaverQuery()
        .restrict([nodeId])
        .first()
      dispatch(setNode(node))
      dispatch(setLoading(false))
    )()
    undefined
  , [])

  <Card
    title={if node then getNodeLabel(node) else <Skeleton.Input style={{ height: 25 }} />}
    className="detail-view-container"
    bordered={false}
    bodyStyle={{ height: 'calc(100vh - 137px)' }}
    loading={not node}
  >
    <Tabs tabPosition="bottom" style={{ height: '100%' }}>
      <TabPane tab={<Hexagon size={18} />} key="1">
        <NodeDetails />
      </TabPane>
      <TabPane tab={<Clock size={18} />} key="2">
        History
      </TabPane>
      <TabPane tab={<Shield size={18} />} key="3">
        Access rights
      </TabPane>
    </Tabs>
  </Card>

export default DetailView